var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-ppm-details__tree-container"},[_c('p',{staticClass:"dg-ppm-details__tree-container__title"},[_vm._v(_vm._s(_vm.$t("ppm.details.subcontractor_tree.title")))]),_c('section',{ref:"subcontractorTree",attrs:{"id":"dg-ppm-details__subcontractor-tree"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }